<template>
  <div :class="['product-price', cssClasses, defaultPriceClass, authenticatedUserPriceClass, campaignPriceClass]">
    <div v-if="!isProduct || showListPrice" :class="['product-price__text', { 'product-price__text--blue-plate': showListPrice }]">
      <template v-if="!isProduct">
        {{ tStatic('fromPriceLabel') }}
      </template>

      <template v-else>
        {{ tStatic('listPriceLabel') }} {{ formatPrice(listPrice) }}
      </template>
    </div>

    <div class="product-price__main">
      <template v-if="!isProduct">
        {{ formatPrice(lowestPrice) }}
      </template>

      <template v-if="isProduct && !priceModel.isCampaignPrice">
        {{ formatPrice(customerPrice) }}
      </template>

      <template v-if="isProduct && priceModel.isCampaignPrice">
        {{ formatPrice(campaignPrice) }}

        <span class="product-price__reduced">{{ formatPrice(customerPrice) }}</span>
      </template>
    </div>

    <div v-if="isProduct && priceModel.isCampaignPrice" class="product-price__text product-price__text--campaign">
      {{ tStatic('campaignPrice') }}
    </div>

    <div class="product-price__text product-price__text--vat">
      {{ useVat ? tStatic('priceIncludingVat') : tStatic('priceExcludingVat') }}
    </div>

    <div v-for="(item, i) in bracketPrices" :key="i">
      <span class="product-price">{{ tStatic('bracketPriceText').replace('{0}', item.quantity).replace('{1}', formatPrice(item.price)) }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
export default {
  props: {
    priceModel: {
      type: Object,
      required: true
    },
    isProduct: {
      type: Boolean,
      required: true
    },
    product: {
      type: Object,
      required: true
    }

  },
  data() {
    return {
      listPrice: this.priceModel.listPrice,
      lowestPrice: this.priceModel.lowestPrice,
      customerPrice: this.priceModel.customerPrice,
      campaignPrice: this.priceModel.campaignPrice,
      bracketPrices: this.priceModel.bracketPrices
    }
  },
  computed: {
    ...mapGetters('ui', ['useVat']),
    ...mapGetters('commerce', ['currentProduct']),
    showListPrice() {
      return this.isProduct && this.listPrice !== this.customerPrice
    },
    isAuthenticated() {
      return this.clientModel.isAuthenticated
    },
    defaultPriceClass() {
      return !this.isAuthenticated && !this.priceModel.isCampaignPrice && 'product-price--default'
    },
    authenticatedUserPriceClass() {
      return this.isAuthenticated && !this.priceModel.isCampaignPrice && 'product-price--authenticated-user'
    },
    campaignPriceClass() {
      return this.priceModel.isCampaignPrice && 'product-price--campaign'
    }
  },
  watch: {
    useVat() {
      this.loadProduct()
    },
    'clientModel.useListPrice'() {
      this.loadProduct()
    },
    currentProduct: {
      deep: true,
      handler(value) {
        if(value.id === this.priceModel.productId) {
          this.lowestPrice = value.lowestPrice
          _.forEach(value.items, (item) => {
            var price = _.filter(value.items, priceItem => priceItem.id === this.clientModel.selectedItem)[0]
            if(price !== null && price !== undefined && price.id === this.clientModel.selectedItem) {
              this.customerPrice = price.customerPrice.customerPrice
              this.campaignPrice = price.customerPrice.campaignPrice
              this.bracketPrices = price.customerPrice.bracketPrices
              this.listPrice = price.customerPrice.listPrice
            }
          })
        }
      }
    }
  },
  mounted() {
    this.loadProduct()
  },
  methods: {
    ...mapActions('commerce', ['getProduct']),
    loadProduct() {
      this.getProduct({ productId: this.priceModel.productId, products: [this.product] })
    }
  }
}
</script>
